import { useMutation } from '@tanstack/react-query';
import { submitSupportTicket } from './api';

/**
 * Support-ticket mutation. No cache to invalidate (there's no support list
 * in v1) — the dialog owns its own success/error UX (toast + close).
 */
export function useSubmitSupportTicket() {
  return useMutation({ mutationFn: submitSupportTicket });
}
